import { Query } from '@cubejs-client/core'
import { InventoryOnHandGroupBy } from '@getgreenline/inventory/build/models/inventory'
import { getEndOfDayWithoutTimezone } from '../../../../../../utilities/date'
import { CubeInventoryLogFields, CubeMaxInventoryLogFields } from './enums'

export const generateMaxIdQuery = ({
  companyId,
  locationIds,
  startDate,
  limit = 50000,
}: {
  companyId: number
  locationIds: number[]
  startDate: Date
  limit?: number
}): Query => ({
  measures: [CubeMaxInventoryLogFields.MAX_ID],
  timeDimensions: [],
  dimensions: [],
  filters: [
    {
      member: CubeMaxInventoryLogFields.CREATE_DATE,
      operator: 'beforeDate',
      values: [`${getEndOfDayWithoutTimezone(startDate)}`],
    },
    {
      member: CubeMaxInventoryLogFields.COMPANY_ID,
      operator: 'equals',
      values: [`${companyId}`],
    },
    {
      dimension: CubeMaxInventoryLogFields.ENTITY_ID,
      operator: 'equals',
      values: locationIds.map((id) => `${id}`),
    },
  ],
  limit,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  order: {},
})

export const generateInventoryOnHandQuery = ({
  maxInventoryLogIds,
  groupBy,
  limit = 10000,
  includeOutOfStock,
}: {
  maxInventoryLogIds: string[]
  groupBy: InventoryOnHandGroupBy.PRODUCTS | InventoryOnHandGroupBy.CATEGORIES
  limit?: number
  includeOutOfStock?: boolean
}): Query => ({
  measures: [
    CubeInventoryLogFields.NEW_VALUE,
    CubeInventoryLogFields.PRODUCT_COST,
    CubeInventoryLogFields.COST,
    CubeInventoryLogFields.PRICE,
    CubeInventoryLogFields.MARGIN,
  ],
  timeDimensions: [],
  dimensions:
    groupBy === InventoryOnHandGroupBy.CATEGORIES
      ? [
          'Categories.parentname',
          'Categories.name',
          'Products.id',
          'Locations.name',
          'Categories.fullname',
        ]
      : [
          'Products.id',
          'Products.sku',
          'Products.fullname',
          'Categories.fullname',
          'Suppliers.name',
          'Products.overrideprice',
          'Locations.name',
        ],
  filters: [
    {
      dimension: CubeInventoryLogFields.ID,
      operator: 'equals',
      values: maxInventoryLogIds,
    },
    {
      member: CubeInventoryLogFields.NEW_VALUE,
      operator: includeOutOfStock ? 'gte' : 'gt',
      values: ['0'],
    },
  ],
  limit,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  order:
    groupBy === InventoryOnHandGroupBy.CATEGORIES
      ? {
          'Categories.fullname': 'asc',
          [CubeInventoryLogFields.NEW_VALUE]: 'desc',
        }
      : {
          'Locations.name': 'asc',
          [CubeInventoryLogFields.NEW_VALUE]: 'desc',
        },
})
